import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import { CartService, StoreGroup } from '../../services/cart.service'

@Component({
  selector: 'app-cart-drawer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './cart-drawer.component.html',
  styleUrl: './cart-drawer.component.css'
})
export class CartDrawerComponent {
  constructor(public cartService: CartService) {}

  decrement(productId: string, current: number) {
    this.cartService.updateQuantity(productId, current - 1)
  }

  increment(productId: string, current: number) {
    this.cartService.updateQuantity(productId, current + 1)
  }

  whatsappLink(group: StoreGroup): string {
    return this.cartService.whatsappLink(group)
  }
}
